import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/AppShell.jsx';

const CommunityHub = lazy(() => import('./components/community_hub.jsx'));
const Maintenance = lazy(() => import('./pages/maintenance.jsx'));
const Loginpage = lazy(() => import('./pages/Login.jsx'));
const ProfilePage = lazy(() => import('./pages/profile.jsx'));
const EditProfilePage = lazy(() => import('./pages/edit_profile.jsx'));
const PublicProfilePage = lazy(() => import('./pages/public_profile.jsx'));
const FollowListPage = lazy(() => import('./pages/follow_list.jsx'));
const Privacy = lazy(() => import('./pages/privacy_policy_page.jsx'));
const Terms = lazy(() => import('./pages/terms_of_service_page.jsx'));
const PostDetails = lazy(() => import('./pages/post_details_page.jsx'));
const PollDetailPage = lazy(() => import('./pages/poll_detail.jsx'));
const LocStyles = lazy(() => import('./pages/loc_styles.jsx'));
const ReadMore = lazy(() => import('./pages/read_more.jsx'));
const NotIt = lazy(() => import('./pages/NotFound.jsx'));
const LocGuide = lazy(() => import('./pages/loc_guide.jsx'));
const JournalPage = lazy(() => import('./pages/journal.jsx'));
const JournalAddPage = lazy(() => import('./pages/journal_add.jsx'));
const JournalEntryPage = lazy(() => import('./pages/journal_entry.jsx'));
const JournalExportPage = lazy(() => import('./pages/journal_export.jsx'));
const CreateGroupPage = lazy(() => import('./pages/create_group.jsx'));
const CommunityWritePage = lazy(() => import('./pages/community_write.jsx'));
const GroupDetailPage = lazy(() => import('./pages/group_detail.jsx'));
const Dashboard = lazy(() => import('./pages/dashboard.jsx'));
const Twin = lazy(() => import('./pages/twin.jsx'));
const About = lazy(() => import('./pages/about.jsx'));
const FeedbackPage = lazy(() => import('./components/feedback_component.jsx'));
const NotificationsPage = lazy(() => import('./pages/notifications.jsx'));

function App() {
  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
        <Route path="/login" element={<Loginpage />} />
        <Route element={<AppShell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/community" element={<CommunityHub />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/twin" element={<Twin />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/edit" element={<EditProfilePage />} />
        <Route path="/u/:uid" element={<PublicProfilePage />} />
        <Route path="/u/:uid/follows" element={<FollowListPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/post-details/:postId" element={<PostDetails />} />
        <Route path="/polls/:pollId" element={<PollDetailPage />} />
        <Route path="/posts" element={<Navigate to="/community" replace />} />
        <Route path="/LocStyles" element={<LocStyles />} />
        <Route path="/readMore" element={<ReadMore />} />
        <Route path="/locguide" element={<LocGuide />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/journal/add" element={<JournalAddPage />} />
        <Route path="/journal/export" element={<JournalExportPage />} />
        <Route path="/journal/:entryId" element={<JournalEntryPage />} />
        <Route path="/u/:uid/journal/:entryId" element={<JournalEntryPage />} />
        <Route path="/community/group/new" element={<CreateGroupPage />} />
        <Route path="/community/write" element={<CommunityWritePage />} />
        <Route path="/community/group/:groupId" element={<GroupDetailPage />} />
        <Route path="/Notit" element={<NotIt />} />
        <Route path="*" element={<NotIt />} />
        </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
